export const Option = ({ onChange, value, id, text, checked, name, children }) => {
    return (
        <div
            className="linkOptionsWrapper"
            style={{ display: "flex", flexDirection: "row", width: "100%" }}
        >
            <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                <input
                    key={Math.random()}
                    type="radio"
                    onChange={onChange}
                    value={value}
                    checked={value === checked}
                    id={id}
                    name={name}
                />
                <label htmlFor={id}>{text}</label>
            </div>
            {children}
        </div>
    )
}